<template>
  <div class="right-lesson-list-component">
    <button @click="handleToggle" class="toggle-btn">
      <i v-if="isShow" class="el-icon-arrow-right" />
      <i v-else class="el-icon-arrow-left" />
    </button>
    <div
      class="right-lesson-list"
      :class="{
        'is-show': isShow,
      }"
    >
      <div class="cont-wrap">
        <div class="course-name">
          <template v-if="canOpenAIModel">
            <button
              v-if="openAiMode"
              v-preventReClick
              @click.stop="changeAiMode"
              class="ai-watch-video-btn"
            >
              <img
                class="ai-icon"
                src="../../../../assets/images/reply/ai-icon.png"
                alt=""
              />
              AI 看课
              <img
                class="close-btn"
                src="../../../../assets/images/icon/close.png"
                alt=""
              />
            </button>
            <button
              v-else
              @click="changeAiMode"
              v-preventReClick
              class="ai-watch-video-btn"
            >
              <img
                class="ai-icon"
                src="../../../../assets/images/reply/ai-icon.png"
                alt=""
              />
              AI 看课
            </button>
          </template>
          <p class="text ellipsis">
            {{ courseInfo.course_name || lessonInfo.course_name }}
          </p>
        </div>
        <!-- 右侧侧边栏：目录课时切换 -->
        <course-card
          v-if="false"
          class="course-card-component"
          :justShowTabList="true"
          :lesson-info="lessonInfo"
          :course-info="courseInfo"
          :havePrivateLesson="courseInfo.havePrivateLesson || 0"
          @changeLesson="onChangeLesson"
        />
        <notes
          ref="notes"
          :componentId="noteComponentId"
          class="notes-container"
          :lesson-info="lessonInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Notes from "@saas/pages/src/video-play/components/Notes";
// import CourseCard from "@saas/pages/src/video-play/components/CourseCard.vue";
import { mapState } from "vuex";
export default {
  props: {
    noteComponentId: {
      type: [String, Number],
      default: null,
    },
    openAiMode: {
      type: Boolean,
      default: false,
    },
    initIsShow: {
      type: Boolean,
      default: true,
    },
    lessonInfo: {
      type: Object,
      default: () => ({}),
    },
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    // CourseCard,
    Notes,
  },
  data() {
    return {
      isShow: true,
      showToggle: true,
    };
  },
  watch: {
    initIsShow: {
      handler(newVal, oldVal) {
        this.isShow = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    onChangeLesson(lesson) {
      this.$emit("changeLesson", lesson);
    },
    changeAiMode() {
      this.$emit("changeAiMode", !this.openAiMode);
    },
    handleToggle() {
      this.isShow = !this.isShow;
    },
    changeIsShow(val) {
      this.isShow = val;
    },
    handleSaveNote() {
      if (this.$refs.notes) {
        this.$refs.notes.onClickSave(false);
      }
    },
  },
  computed: {
    ...mapState("replay", ["canOpenAIModel"]),
  },
};
</script>

<style scoped lang="scss">
$rightContentWidth: 340px;
.right-lesson-list-component {
  --right-lesson-list-bg: var(--replay-ai-page-bg, #e3f8eb);
  --right-lesson-list-title-bg: var(
    --replay-ai-title-bg,
    linear-gradient(135deg, #f4fff8 0%, #fefeff 87%, #f9fbff 100%)
  );
  --right-lesson-list-title-border: var(--replay-ai-title-border, #ffffff);
  --right-lesson-list-title-text: var(--replay-ai-title-text, #0d1400);

  position: relative;
  flex: 0 0 auto;
  height: 100vh;
  background: var(--right-lesson-list-bg);
  .toggle-btn {
    position: absolute;
    top: 50%;
    left: -30px;
    transform: translateY(-50%);
    width: 30px;
    height: 90px;
    background: #1d1e22;
    border-radius: 8px 0px 0px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 18px;
      color: #fff;
      font-weight: bold;
    }
  }
  .right-lesson-list {
    width: 0;
    height: 100vh;
    box-sizing: border-box;
    transition: width 0.3s ease;
    overflow: hidden;
    background: var(--right-lesson-list-bg);
    &.is-show {
      width: $rightContentWidth;
    }
    .cont-wrap {
      display: flex;
      flex-direction: column;
      height: 100vh;
      padding: 20px;
      width: 100%;
      box-sizing: border-box;
    }
  }
  .course-name {
    width: 100%;
    height: 44px;
    background: var(--right-lesson-list-title-bg);
    border-radius: 6px;
    border: 1px solid var(--right-lesson-list-title-border);
    display: flex;
    align-items: center;
    padding-left: 8px;
    padding-right: 12px;
    .text {
      flex: 1;
      width: 0;
      font-size: 14px;
      color: var(--right-lesson-list-title-text);
      line-height: 32px;
    }
  }
  .ai-watch-video-btn {
    margin-right: 4px;
    padding-right: 4px;
    min-width: 80px;
    width: max-content;
    height: 28px;
    background: var(--replay-ai-button-bg, #ffffff);
    border-radius: 6px;
    border: 1px solid var(--replay-ai-button-border, #ffffff);
    font-weight: 500;
    font-size: 14px;
    color: var(--replay-ai-button-text, #232a18);
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &:disabled {
      opacity: 1;
    }
    .ai-icon {
      width: 28px;
      height: 28px;
    }
    .close-btn {
      width: 14px;
      height: 14px;
      margin-left: 6px;
      margin-right: 2px;
    }
  }
  .course-card-component {
    margin-left: 0;
  }
}
.notes-container {
  padding: 8px 0;
  width: calc($rightContentWidth - 40px);
  flex: 1;
  height: 0;
}

html.dark .right-lesson-list-component,
html.theme-dark .right-lesson-list-component,
html[data-theme="dark"] .right-lesson-list-component {
  --right-lesson-list-bg: var(--mg-bg-page);
  --right-lesson-list-title-bg: var(--mg-bg-card);
  --right-lesson-list-title-border: var(--mg-border-subtle);
  --right-lesson-list-title-text: var(--mg-text-primary);
}
</style>
